<div *ngIf="carousel" class="carousel-wrapper">
  <div class="keen-navigation-wrapper">
    <div
      *ngIf="!isMobile && showArrows"
      class="arrow arrow-left"
      (click)="doPrev()"
    >
      <img src="/assets/icons/carousel-arrow-right.svg" alt="" />
    </div>
    <div class="keen-slider" #sliderRef>
      <div
        *ngFor="let slide of carousel; index as slideIndex"
        class="keen-slider__slide"
        [class.min-width]="isMobile"
      >
        <div
          class="carousel-slide"
          [class.active-slide]="!isMobile || slideIndex === currentSlideIndex"
        >
          <div class="slide-top">
            <h2>{{ slide.title }}</h2>
          </div>
          <div class="slide-bottom">
            <p>{{ slide.description }}</p>
          </div>
          <div class="link-container">
            <a [href]="slide.link ?? slide.route"
              ><button>{{ slide.button_text }}</button></a
            >
          </div>
        </div>
      </div>
    </div>
    <div
      *ngIf="!isMobile && showArrows"
      class="arrow arrow-right"
      (click)="doNext()"
    >
      <img src="/assets/icons/carousel-arrow-right.svg" alt="" />
    </div>
  </div>
</div>
